import { render, staticRenderFns } from "./details-orders.vue?vue&type=template&id=74977fd8&scoped=true"
import script from "./details-orders.vue?vue&type=script&lang=js"
export * from "./details-orders.vue?vue&type=script&lang=js"
import style0 from "./details-orders.vue?vue&type=style&index=0&id=74977fd8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74977fd8",
  null
  
)

export default component.exports